import React, { useState } from 'react';
import injectSheet from 'react-jss';
import createAuthAuthenticate from '@testnotify/core/api/create-auth-authenticate';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { setLogin, setProfile } from '../../store/auth';

// Components
import Button from '../Button';
import Input from '../Input';
import ErrorMessage from '../ErrorMessage';
import Divider from '../Divider';
import FacebookAuthButton from '../FacebookAuthButton';
import Link from 'next/link';

interface Props {
  classes: any;
}

function SignInForm({ classes }: Props) {
  const dispatch = useDispatch();
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [forceDisable, setForceDisable] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onSignIn = () => {
    setForceDisable(true);
    dispatch(setLogin({ authToken: 'lolcats', email }));
    // dispatch(setProfile({ testCenterSelected: 'lolcats', identifierSelected: 'lolcats' }));
    // createAuthAuthenticate({ email, password })
    //   .then(({ authToken }) => {
    //     dispatch(setLogin({ authToken, email }));
    router.push('/settings');
    //   })
    //   .catch(error => {
    //     setForceDisable(false);
    //     setErrorMessage('Email or password is not valid.');
    //   });
  };

  return (
    <>
      <h2>Sign In</h2>
      <Input
        placeholder="Email address"
        focus={true}
        forId="login-email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        disabled={forceDisable}
      />
      <Input
        placeholder="Password"
        type="password"
        forId="login-password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        disabled={forceDisable}
      />
      <Button color="moonBlue" onClick={onSignIn} disabled={forceDisable}>
        Sign In
      </Button>
      <ErrorMessage message={errorMessage} />
      <Divider />
      <FacebookAuthButton buttonType="continue_with" />
      <Divider />
      <div className={classes.helpfulLinks}>
        <Link href="/forgot-password">
          <a href="/forgot-password">Forgot your password?</a>
        </Link>
        <Link href="/sign-up">
          <a href="/sign-up">Looking to create an account?</a>
        </Link>
      </div>
    </>
  );
}

const styles = theme => {
  return {
    helpfulLinks: {
      marginTop: theme.spacing.unit * 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& > *': {
        marginBottom: theme.spacing.unit,
      },
    },
  };
};

export default injectSheet(styles)(SignInForm);
